import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, DatePicker, Switch } from "antd";
import { useEffect, useRef, useState } from "react";
import { useNavigate,useParams } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, checkp, formatDate, dayjsDate, formatDate2 } from '../../utils/functions'
import { PlusOutlined, EditOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import renderFileList from "../../components/renderFileList";
import ImgUploader from "../../components/ImgUploader";
import CustModal from "../../components/ShowModal";

const { Option } = Select;
function TemplateManager() {
    const { type } = useParams();
    const webPost = useWebPost();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const pageSizeOptions = [10, 20, 50, 100, 500];

    const [form] = Form.useForm();
    const [editingRecord, setEditingRecord] = useState(null);
    const loadingRef = useRef();
    const [canEdit, setCanEdit] = useState(false);

    useEffect(()=>{
        setCurrentPage(1);
        setFilters({});
        setfreshData(Math.random());
        let canmod = checkp(['zxgldd']);
        setCanEdit(canmod);
    },[type])
    useEffect(() => {
        const fetchItems = () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            try {
                const params = { type, page: currentPage, limit: pageSize, ...filters };
                webPost('TemplateList', params).then((response) => {
                    if (response && response.data) {
                        if (response.total < 1) {
                            message.info('未找到匹配数据');
                        }
                        setData(response.data);
                        setTotal(response.total);
                    }
                })
            } catch (e) {
                setData([]);
                setTotal(0);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
        fetchItems();
    }, [currentPage, pageSize, filters, freshData]);

    const columns = [
        {
            title: '序号',
            dataIndex: 'sn',
            key: 'sn',
            width: 80,
            fixed: 'left',
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        { title: '模板名称', dataIndex: 'name', key: 'name' },
        { title: '类型', dataIndex: 'lx', key: 'lx' },
        { title: '专业', dataIndex: 'zy', key: 'zy' },
        {
            title: '文件列表（点击下载或右键保存）',
            dataIndex: 'files',
            key: 'files',
            render: (v) => renderFileList(v),
        },
        ['4'].includes(type) &&{
            title: '平台备案',
            dataIndex: 'files1',
            key: 'files1',
            render: (v) => renderFileList(v),
        },
         { title: '备注', dataIndex: 'ps', key: 'ps' },
        checkp(['zxgldd']) && {
            title: '操作',
            key: 'action',
            width: 150,
            render: (_, record) => (
                <Space size="middle">
                    <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => showModal(record)}
                    >
                        修改
                    </Button>
                    <Button
                        type="link"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(record.id)}
                    >
                        删除
                    </Button>
                </Space>
            ),
        },
    ].filter(Boolean);

    const showModal = (record = null) => {
        setEditingRecord(record);
        if (record) {
            form.setFieldsValue({
                ...record
            });
        } else {
            form.resetFields();
        }
        setModalVisible(true);
    };
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const payload = {
                ...values, id: editingRecord?.id || 0, type
            };

            const res = await webPost('TemplateSave', payload);
            if (res) {
                message.success(editingRecord ? '更新成功' : '新增成功');
                saveSuccess();
            }
        } catch (err) {
            console.error('表单验证或提交错误:', err);
        }
    };

    // 删除记录
    const handleDelete = async (id) => {
        Modal.confirm({
            title: '确认删除？',
            content: '此操作不可恢复',
            onOk: async () => {
                const res = await webPost('TemplateDel', { id });
                if (res) {
                    message.success('删除成功');
                    saveSuccess();
                } else {
                    message.error('删除失败');
                }
            },
        });
    };
    const handleModalClose = () => {
        setModalVisible(false);
        setEditingRecord(null);
    }
    const saveSuccess = () => {
        setfreshData(Math.random()); //强制刷新数据
        handleModalClose();
    };
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    return (
        <FullHeightLayout
            headerContent={
                <Space style={{ 'display': 'flex', 'width': '100%' }}>
                    <Input value={filters?.mc} placeholder='名称' onChange={(e) => { setFilters(prev => ({ ...prev, mc: e.target.value })) }} />
                    <div style={{ 'flex': 1 }}></div>
                    {canEdit && <Button type="primary" icon={<PlusOutlined />} onClick={() => showModal()}>
                        上传新模板
                    </Button>}
                </Space>}
            bodyContent={
                <>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="id"
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 'max-content',
                            y: 'calc(100% - 20px)',
                        }}
                        tableLayout="fixed"
                    />
                    <CustModal
                        title={editingRecord ? '编辑模板' : '上传新模板'}
                        open={modalVisible}
                        onOk={handleOk}
                        onCancel={() => setModalVisible(false)}
                        okText="保存"
                        cancelText="取消"
                        width={700}
                        style={{
                            maxWidth: '80vw',
                            maxHeight: '80vh',
                            overflow: 'auto'
                        }}
                    >
                        <Form form={form} layout="vertical">
                            <Form.Item
                                name="name"
                                label="模板名称"
                                rules={[{ required: true, message: '请输入名称' }]}
                            >
                                <Input  />
                            </Form.Item>
                            <Form.Item name="lx" label="类型">
                                <Input />
                            </Form.Item>
                            <Form.Item name="zy" label="专业">
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="files"
                                label="文件列表"
                            >
                                <ImgUploader />
                            </Form.Item>
                            {['4'].includes(type) && <Form.Item name="files1" label="平台备案">
                                <ImgUploader />
                            </Form.Item>}
                            <Form.Item name="ps" label="备注">
                                <Input.TextArea />
                            </Form.Item>
                        </Form>
                    </CustModal>
                </>
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                        onChange={onPageChange}
                        pageSizeOptions={pageSizeOptions}
                    />
                </div>
            }
        />
    )
}


export default TemplateManager;
